/* ONNI: "In meinen Warenkorb" auf der Produktkarte + Groessen-Layer.
   Auftrag Paavo 15.08.2026.

   Grundsatz: das Einlegen macht NICHT dieses Skript, sondern das theme-eigene
   product-form-component. Wir setzen nur die Variante und druecken auf Absenden.
   Damit bleiben Warenkorb-Drawer, Cart-Bubble, fly-to-cart und die
   Haekchen-Animation unveraendert.
*/
(function () {
  'use strict';

  if (window.__onniCardAtc) return;
  window.__onniCardAtc = true;

  var layer = null;
  var offeneKarte = null;

  /* ---------------------------------------------- Texte

     Die sichtbaren Texte kommen aus snippets/onni-atc-layer.liquid und damit
     aus den Locale-Dateien. Ohne Bruecke faellt es auf Deutsch zurueck, so wie
     es vorher fest im Skript stand. */

  function T(schluessel, ersatz) {
    var texte = window.ONNI_ATC_TEXTE;
    return (texte && texte[schluessel]) || ersatz;
  }

  /* ---------------------------------------------- Warenkorb-Zustand */

  // Gezaehlt wird je Produkt, nicht je Variante: Serum 100 ml + 200 ml ist
  // "Ist drin (2)". Vorher zaehlte nur die gerade gewaehlte Groesse, dann
  // stand bei zwei Groessen nur "Ist drin" (Paavo 30.09.2026). Aufsummiert
  // wird auch, weil dieselbe Variante in mehreren Zeilen liegen kann.
  var korb = {}; // productId -> Menge

  // Code-Review A-05: gemeinsamer Leser aus layout/theme.liquid, und nur, wenn auf der
  // Seite ueberhaupt Karten-Knoepfe stehen.
  function korbHolen() {
    if (typeof window.onniKorb === 'function') return window.onniKorb();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  function korbLesen() {
    if (!document.querySelector('[data-onni-atc]')) return Promise.resolve();
    return korbHolen()
      .then(function (c) {
        korb = {};
        if (c && c.items) {
          c.items.forEach(function (i) {
            var pid = String(i.product_id);
            korb[pid] = (korb[pid] || 0) + i.quantity;
          });
        }
        kartenZeichnen();
      })
      .catch(function () { /* still bleiben, der Knopf funktioniert trotzdem */ });
  }

  var HAKEN = '<span class="onni-atc__haken" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>';

  // Der Text sitzt je nach Knopf unterschiedlich tief: der echte Absende-Knopf
  // kommt aus add-to-cart-button.liquid und schachtelt zweimal, der Layer-Oeffner
  // nur einmal.
  // Der Haken muss beim Oeffner-Knopf ausgeschlossen werden: er sitzt als
  // erstes span im Knopf, ein blankes querySelector('span') haette ihn getroffen
  // und beim zweiten Durchlauf mit dem Text ueberschrieben -> "Ist drin Ist drin"
  // ohne Haken (Paavo 15.08.2026).
  function textFeld(knopf) {
    return knopf.querySelector('.add-to-cart-text__content span span')
        || knopf.querySelector('.add-to-cart-text__content span')
        || knopf.querySelector(':scope > span:not(.onni-atc__haken)');
  }

  function kartenZeichnen() {
    document.querySelectorAll('[data-onni-atc]').forEach(function (karte) {
      var menge = korb[String(karte.dataset.productId || '')] || 0;
      var drin = menge > 0;

      karte.classList.toggle('onni-atc--drin', drin);
      karte.classList.add('onni-atc--bereit');

      karte.querySelectorAll('.onni-atc__button').forEach(function (knopf) {
        var feld = textFeld(knopf);
        if (!feld) return;
        feld.textContent = drin
          ? (menge > 1 ? T('in_cart_count', 'Ist drin (%anzahl%)').replace('%anzahl%', menge) : T('in_cart_short', 'Ist drin'))
          : T('add_to_cart', 'In meinen Warenkorb');

        var haken = knopf.querySelector('.onni-atc__haken');
        if (drin && !haken) knopf.insertAdjacentHTML('afterbegin', HAKEN);
        if (!drin && haken) haken.remove();
      });
    });
  }

  /* ---------------------------------------------- Einlegen */

  function variantSetzen(karte, vid) {
    var feld = karte.querySelector('[data-onni-atc-variant]');
    if (feld) feld.value = vid;
    karte.dataset.variantId = vid;
  }

  // Der Drawer oeffnet sich nur, wenn cart-drawer-component das Attribut
  // auto-open traegt. Wir nehmen es kurz weg, statt den Drawer hinterher
  // wieder zuzumachen - das wuerde aufblitzen.
  // Code-Review 82 (Johannes 20.10.2026): Vorher kam auto-open nach festen 2 Sekunden zurueck,
  // bei langsamer Antwort ging der Drawer doch auf. Jetzt erst nach dem cart:update dieses
  // Einlegens (der Drawer hat es dann schon gesehen), 10 s nur als Rueckfall bei Fehlern.
  var stummerDrawer = null;
  var stummTimer = null;
  function drawerLaut() {
    clearTimeout(stummTimer);
    if (stummerDrawer) stummerDrawer.setAttribute('auto-open', '');
    stummerDrawer = null;
  }
  function drawerStummschalten() {
    var d = document.querySelector('cart-drawer-component[auto-open]');
    if (!d) return;
    d.removeAttribute('auto-open');
    stummerDrawer = d;
    clearTimeout(stummTimer);
    stummTimer = setTimeout(drawerLaut, 10000);
  }

  // Bereiche mit data-onni-atc-drawer (z. B. Birthday-Angebotsbox) wollen den
  // Drawer wie auf der PDP, nicht die kleine Leiste (Paavo 06.10.2026).
  function mitDrawer(karte) {
    return !!(karte && karte.closest('[data-onni-atc-drawer]'));
  }

  function absenden(karte) {
    var form = karte.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    if (mitDrawer(karte)) { form.requestSubmit ? form.requestSubmit() : form.submit(); return; }
    drawerStummschalten();
    letzteKarte = karte;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  /* ---------------------------------------------- Warenkorb-Leiste */

  var letzteKarte = null;
  var barTimer = null;

  function leisteZeigen(karte) {
    var bar = document.querySelector('[data-onni-bar]');
    if (!bar || !karte) return;

    var karteEl = karte.closest('product-card');
    var bild = karteEl && karteEl.querySelector('img');
    var bildEl = bar.querySelector('[data-onni-bar-bild]');
    if (bildEl && bild) bildEl.src = bild.currentSrc || bild.src;

    var groesse = '';
    var aktiv = karte.querySelector('.onni-atc-tile--aktiv .onni-atc-tile__size');
    if (aktiv) groesse = ', ' + aktiv.textContent.trim();

    var zeile = bar.querySelector('[data-onni-bar-zeile]');
    var basis = (karte.dataset.productTitle || '') + groesse;
    if (zeile) zeile.textContent = basis;

    bar.hidden = false;
    clearTimeout(barTimer);
    barTimer = setTimeout(function () { bar.hidden = true; }, 4500);

    // Anzahl und Summe nachtragen, sobald der Warenkorb geantwortet hat
    korbHolen()
      .then(function (c) {
        if (!c || !zeile) return;
        var summe = (c.total_price / 100).toFixed(2).replace('.', ',') + ' \u20AC';
        zeile.textContent = basis + ' \u00B7 ' + c.item_count + ' ' + T('items_word', 'Artikel') + ', ' + summe;
      })
      .catch(function () {});
  }

  /* ---------------------------------------------- Layer */

  function layerHolen() {
    if (!layer) layer = document.querySelector('[data-onni-atcl]');
    return layer;
  }

  function layerOeffnen(karte) {
    var l = layerHolen();
    var tiles = karte.querySelector('[data-onni-atc-tiles]');
    if (!l || !tiles) return;

    offeneKarte = karte;
    l.querySelector('[data-onni-atcl-titel]').textContent = karte.dataset.productTitle || '';

    var gitter = l.querySelector('[data-onni-atcl-gitter]');
    gitter.innerHTML = '';
    gitter.dataset.spalten = tiles.children.length;

    // Kacheln wandern in den Layer, damit sie nur einmal existieren und die
    // von discount.js geschriebenen Preise mitnehmen.
    // Achtung: children ist eine LEBENDE Liste. Beim Verschieben schrumpft sie
    // waehrend der Schleife, ohne Kopie kaeme nur jede zweite Kachel an.
    Array.prototype.slice.call(tiles.children).forEach(function (t) { gitter.appendChild(t); });

    var aktiv = gitter.querySelector('.onni-atc-tile--aktiv');
    if (!aktiv) {
      aktiv = gitter.querySelector('.onni-atc-tile:not([disabled])');
      if (aktiv) kachelWaehlen(aktiv);
    }

    l.hidden = false;
    document.documentElement.classList.add('onni-atcl-offen');
    // Fokus aufs Blatt, nicht auf den Knopf: sonst zeichnet der Browser einen
    // Fokusrahmen um den CTA, der wie ein doppelter Rand aussieht.
    var blatt = l.querySelector('.onni-atcl__blatt');
    if (blatt) blatt.focus();
  }

  function layerSchliessen() {
    var l = layerHolen();
    if (!l || l.hidden) return;

    // Kacheln zurueck in ihre Karte
    if (offeneKarte) {
      var heim = offeneKarte.querySelector('[data-onni-atc-tiles]');
      var gitter = l.querySelector('[data-onni-atcl-gitter]');
      if (heim && gitter) {
        Array.prototype.forEach.call(Array.prototype.slice.call(gitter.children), function (t) {
          heim.appendChild(t);
        });
      }
    }

    l.hidden = true;
    document.documentElement.classList.remove('onni-atcl-offen');
    offeneKarte = null;
  }

  function kachelWaehlen(kachel) {
    var gitter = kachel.parentElement;
    if (!gitter) return;
    Array.prototype.forEach.call(gitter.children, function (t) {
      t.classList.remove('onni-atc-tile--aktiv');
      t.setAttribute('aria-checked', 'false');
    });
    kachel.classList.add('onni-atc-tile--aktiv');
    kachel.setAttribute('aria-checked', 'true');
    if (offeneKarte) variantSetzen(offeneKarte, kachel.dataset.variantId);
  }

  /* ---------------------------------------------- Verdrahtung */

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    // Der Knopf bei Produkten mit EINER Groesse ist der echte Absende-Knopf des
    // Theme-Formulars, er laeuft nicht durch absenden(). Wir haengen uns hier an,
    // ohne den Klick zu stoppen, damit Drawer-Stummschaltung und Leiste greifen.
    var direkt = t.closest('.onni-atc__submit button');
    if (direkt) {
      var kd = t.closest('[data-onni-atc]');
      if (kd && !mitDrawer(kd)) { letzteKarte = kd; drawerStummschalten(); }
      return;
    }

    if (t.closest('[data-onni-atc-open]')) {
      ev.preventDefault();
      ev.stopPropagation();
      var karte = t.closest('[data-onni-atc]');
      if (karte) layerOeffnen(karte);
      return;
    }

    if (t.closest('[data-onni-atcl-close]')) {
      ev.preventDefault();
      layerSchliessen();
      return;
    }

    // Klick auf eine Groesse legt DIREKT ein (Paavo 15.08.2026). Der Knopf
    // darunter bleibt trotzdem, fuer den Fall dass die vorgewaehlte Groesse
    // schon passt und man nur bestaetigen will.
    var kachel = t.closest('.onni-atc-tile');
    if (kachel && !kachel.disabled) {
      ev.preventDefault();
      kachelWaehlen(kachel);
      var karte2 = offeneKarte;
      layerSchliessen();
      if (karte2) absenden(karte2);
      return;
    }

    if (t.closest('[data-onni-bar-zu]')) {
      ev.preventDefault();
      var barZu = document.querySelector('[data-onni-bar]');
      if (barZu) barZu.hidden = true;
      return;
    }

    if (t.closest('[data-onni-bar-auf]')) {
      ev.preventDefault();
      var barAuf = document.querySelector('[data-onni-bar]');
      if (barAuf) barAuf.hidden = true;
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else location.href = '/cart';
      return;
    }

    if (t.closest('[data-onni-atcl-add]')) {
      ev.preventDefault();
      if (offeneKarte) {
        var k = offeneKarte;
        layerSchliessen();
        absenden(k);
      }
      return;
    }

  }, true);

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') layerSchliessen();
  });

  // Nach jedem Einlegen den Zustand nachziehen (Gruen + Menge).
  document.addEventListener('cart:update', function (ev) {
    if (stummerDrawer) setTimeout(drawerLaut, 0);
    if (ev.detail && ev.detail.source === 'onni-card-atc') return;
    korbLesen();
    if (letzteKarte) {
      leisteZeigen(letzteKarte);
      letzteKarte = null;
    }
  });

  // Nach dem Pillen-Wechsel sind die Karten neu, „Ist drin“ fehlte (Code-Review A-04).
  // Der Korb hat sich nicht geaendert, Neuzeichnen reicht.
  document.addEventListener('onni:collection-swapped', kartenZeichnen);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', korbLesen);
  } else {
    korbLesen();
  }
})();
